import { ChangePartnerMenuController } from '../controller/ChangePartnerMenuController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { CompanyData } from '../../../types/company-data';

export class ChangePartnerMenuWebComponent extends BaseWebComponentElement {
  public controller: ChangePartnerMenuController | null;
  public company: CompanyData;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ChangePartnerMenuController,
    });
  }

  public setCompany(company: CompanyData) {
    this.company = company;
    this.controller?.view.setCompany(company);
  }

  public async reloadMenu() {
    await this.controller?.reloadMenu();
  }
}
